import React, { Component } from 'react';

class SearchErr extends Component {
    render() {
        return (
            <div className="result-group no-result">
	            <div className="icon icon-result icon-no-result">
                </div>
                <div className="text-result">
                    검색 결과가 없습니다.
                </div>
            </div>
        );
    }
}

export default SearchErr;


// WEBPACK FOOTER //
// ./src/components/errorpage/SearchErr.js